import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { fetchJasonLOrder } from '../../state/services/extraService';
import { openTab } from '../../commons/browser';

class JasonLOrderModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderId: null,
            bookingId: null,
            errorMessage: null,
        };
    }

    static propTypes = {
        history: PropTypes.object.isRequired,
        isOpen: PropTypes.bool,
        toggleModal: PropTypes.func,
        fetchJasonLOrder: PropTypes.func.isRequired,
        message: PropTypes.string,
        extraErrorMessage: PropTypes.string,
        isFetchingJasonLOrder: PropTypes.bool,
        isImportable: PropTypes.bool,
        jasonlBookingUrl: PropTypes.string,
        jasonlPricePageUrl: PropTypes.string,
    };

    static defaultProps = {
        isOpen: false,
        message: '',
        extraErrorMessage: '',
        isFetchingJasonLOrder: false,
        jasonlBookingUrl: null,
        jasonlPricePageUrl: null
    };

    // UNSAFE_componentWillReceiveProps(newProps) {
    // }

    handleInputChange(e) {
        const orderNumber = e.target.value;
        this.setState({orderNumber, errorMessage: null});
    }

    onClickFetch() {
        if (!this.state.orderNumber) {
            this.setState({errorMessage: 'Order Number is required.'});
            return;
        }

        this.props.fetchJasonLOrder(this.state.orderNumber, false);
    }

    onClickFetchAgain() {
        if (!this.state.orderNumber) {
            this.setState({errorMessage: 'Order Number is required.'});
            return;
        }

        this.props.fetchJasonLOrder(this.state.orderNumber, true);
    }

    onClickGotoBooking() {
        openTab(this.props.jasonlBookingUrl);
    }

    onClickGotoPricePage() {
        openTab(this.props.jasonlPricePageUrl);
    }
    
    render() {
        const {orderNumber} = this.state;
        const {
            extraErrorMessage, message, isFetchingJasonLOrder, jasonlBookingUrl, jasonlPricePageUrl, isImportable
        } = this.props;
        const {isOpen} = this.props;

        return (
            <ReactstrapModal isOpen={isOpen} toggle={() => this.props.toggleModal()} className="switch-user-modal">
                <ModalHeader toggle={() => this.props.toggleModal()}>Fetch Order from Jason L (Pronto)</ModalHeader>
                <ModalBody>
                    <label>
                        Order Number:&nbsp;&nbsp;
                        <input
                            required 
                            name="orderNumber" 
                            onChange={(e) => this.handleInputChange(e)}
                            value={orderNumber}
                        />
                    </label>
                    {extraErrorMessage && <p className='c-red'>{extraErrorMessage}</p>}
                    {message && <p className='c-red'>{message}</p>}
                </ModalBody>
                <ModalFooter>
                    {jasonlBookingUrl &&
                        <Button color="success" onClick={() => this.onClickGotoBooking()}>
                            Go To Booking
                        </Button>
                    }
                    {jasonlPricePageUrl &&
                        <Button color="success" onClick={() => this.onClickGotoPricePage()}>
                            Go To Price page
                        </Button>
                    }
                    {(isImportable && jasonlPricePageUrl) &&
                        <Button color="danger" onClick={() => this.onClickFetchAgain()}>
                            Fetch Again
                        </Button>
                    }
                    <Button color="primary" onClick={() => this.onClickFetch()} disabled={isFetchingJasonLOrder}>
                        {isFetchingJasonLOrder ? 'Fetching...' : 'Fetch'}
                    </Button>
                    <Button color="secondary" onClick={() => this.props.toggleModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        isFetchingJasonLOrder: state.extra.isFetchingJasonLOrder,
        message: state.extra.message,
        extraErrorMessage: state.extra.errorMessage,
        jasonlBookingUrl: state.extra.jasonlBookingUrl,
        jasonlPricePageUrl: state.extra.jasonlPricePageUrl,
        isImportable: state.extra.isImportable,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchJasonLOrder: (bok_1, fetchAgain) => dispatch(fetchJasonLOrder(bok_1, fetchAgain)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(JasonLOrderModal);



// WEBPACK FOOTER //
// ./src/components/CommonModals/JasonLOrderModal.js